module.exports = __webpack_public_path__ + "static/beach-406e3b38c75aec2ab692ec77d3ac0cb4.jpg";